export default __webpack_public_path__ + "static/media/4.12f15c77.png";